import { Injectable } from '@angular/core';
import * as signalR from "@aspnet/signalr";
import { HttpService } from './http.service';
import { NotifyService } from '../services/notify.service';
@Injectable()
export class SignalRService {
    private hubConnection: signalR.HubConnection
    constructor(private http: HttpService, protected notify: NotifyService) {
    }

    public startConnection = () => {
        this.hubConnection = new signalR.HubConnectionBuilder()            
            .withUrl(this.http.getUrl() + 'crmHub')
            .build();

        this.hubConnection
            .start()
            .then(() => console.log('Connection started'))
            .catch(err => console.log('Error while starting connection: ' + err))
    }

    public addTransferTenderStateListener = () => {
        this.hubConnection.on('NewComments', (data) => {
            //this.data = data;
            console.log('Get from server ', data);
            this.notify.sendNewComment('NewComments', data);
        });
    }
}
